export default "__VITE_ASSET__rqmAk7sB__"